import { joinList } from "lib/join-list"
import { FieldSelectorAlertError } from "slot-definitions"
import { FieldErrorsMessage } from "../../fields-errors-message"
import { FIELD_ERROR_INVALID_SELECTION } from "lib/@components/extended-select/plugins/invalid-selection-field-error/invalid-selection-field-error.runtime"

FieldSelectorAlertError.plug(<InvalidSelectionFieldsError priority={200} />)

function InvalidSelectionFieldsError() {
    return (
        <FieldErrorsMessage
            errorType={FIELD_ERROR_INVALID_SELECTION}
            message={(fields) => {
                const verb = fields.length > 1 ? "each have" : "has"
                return `${joinList(
                    fields
                )} ${verb} an invalid value not available for selection - please select a different value${
                    fields.length > 1 ? " for each field" : ""
                }.`
            }}
        />
    )
}
